import React from 'react';

export function Aidraft(props: {
    draft: string
}) {
    return <pre className="mw-100" style={{whiteSpace: 'pre-wrap'}}>{props.draft}</pre>;
}